export default __webpack_public_path__ + "static/media/settings.72caaad6.svg";